<template>
  <div>
    <div class="vs-row">
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Form Inputs</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <vs-row vs-w="12" class="mb-3">
              <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
                <vs-input
                  :success="fnamesuccess"
                  success-text="First Name is valid."
                  :danger="fnamedanger"
                  danger-text="First Name is required."
                  label="First Name"
                  class="w-full"
                  v-model="fname"
                  placeholder="First Name"
                  name="input1"
                />
              </vs-col>
              <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
                <vs-input
                  :success="lnamesuccess"
                  success-text="Last Name is valid."
                  :danger="lnamedanger"
                  danger-text="Last Name is required."
                  label="Last Name"
                  class="w-full"
                  v-model="lname"
                  placeholder="Last Name"
                />
              </vs-col>
            </vs-row>
            <vs-row vs-w="12" class="mb-3">
              <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                <vs-input
                  :success="addresssuccess"
                  success-text="Address is valid."
                  :danger="addressdanger"
                  danger-text="Address is required."
                  label="Address"
                  class="w-full"
                  v-model="address"
                  placeholder="1234 Main St"
                />
              </vs-col>
            </vs-row>
            <vs-row vs-w="12" class="mb-3">
              <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                <vs-input
                  :success="address2success"
                  success-text="Address 2 is valid."
                  :danger="address2danger"
                  danger-text="Address 2 is required."
                  label="Address 2"
                  class="w-full"
                  v-model="address2"
                  placeholder="Appartment, Studio"
                />
              </vs-col>
            </vs-row>
            <vs-row vs-w="12" class="mb-3">
              <vs-col vs-lg="5" vs-sm="6" vs-xs="12">
                <vs-input
                  :success="citysuccess"
                  success-text="City is valid."
                  :danger="citydanger"
                  danger-text="City is required."
                  label="City"
                  class="w-full"
                  v-model="city"
                  placeholder="City"
                />
              </vs-col>
              <vs-col vs-lg="4" vs-sm="6" vs-xs="12">
                <vs-select
                  v-model="select1"
                  :success="statessuccess"
                  success-text="State is valid."
                  :danger="statesdanger"
                  danger-text="State is required."
                  class="w-full"
                  label="State"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.text"
                    v-for="(item, index) in states"
                    class="w-full"
                  />
                </vs-select>
              </vs-col>
              <vs-col vs-lg="3" vs-sm="6" vs-xs="12">
                <vs-input
                  :success="zipsuccess"
                  success-text="Zip is valid."
                  :danger="zipdanger"
                  danger-text="Zip is required."
                  label="Zip"
                  v-model="zip"
                  class="w-full"
                  placeholder="Zip"
                />
              </vs-col>
            </vs-row>
            <vs-row vs-w="12" class="mb-3">
              <vs-col vs-lg="6" vs-sm="6" vs-xs="12" class="left">
                <vs-button @click.prevent="validationForm"> Submit </vs-button>
              </vs-col>
            </vs-row>
          </div>
        </div>
      </vs-col>
    </div>
  </div>
</template>
<script>
export default {
  watch: {
    "$store.state.theme"(val) {
      this.chartTheme(val);
    },
  },
  methods: {
    chartTheme(val) {
      let mode = val == "dark" ? "dark" : "light";
      return mode;
    },
    validationForm() {
      if (!this.fname) {
        this.fnamedanger = true;
      } else {
        this.fnamesuccess = true;
      }
      if (!this.lname) {
        this.lnamedanger = true;
      } else {
        this.lnamesuccess = true;
      }

      if (!this.address) {
        this.addressdanger = true;
      } else {
        this.addresssuccess = true;
      }
      if (!this.address2) {
        this.address2danger = true;
      } else {
        this.address2success = true;
      }
      if (!this.city) {
        this.citydanger = true;
      } else {
        this.citysuccess = true;
      }

      if (!this.state) {
        this.statedanger = true;
      } else {
        this.statesuccess = true;
      }

      if (!this.zip) {
        this.zipdanger = true;
      } else {
        this.zipsuccess = true;
      }

      if (!this.option) {
        this.optiondanger = true;
      } else {
        this.optionsuccess = true;
      }

      if (!this.select1) {
        this.statesdanger = true;
      } else {
        this.statessuccess = true;
      }
    },
  },
  mounted() {
    this.chartTheme(this.$store.state.theme);
  },
  data: function () {
    return {
      fname: "",
      select1: "",
      fnamesuccess: false,
      fnamedanger: false,
      lname: "",
      lnamesuccess: false,
      lnamedanger: false,
      address: "",
      addresssuccess: false,
      addressdanger: false,
      address2: "",
      address2success: false,
      address2danger: false,
      city: "",
      citysuccess: false,
      citydanger: false,
      state: "",
      statesuccess: false,
      statedanger: false,
      zip: "",
      zipsuccess: false,
      zipdanger: false,
      states: [
        { text: "New York", value: "new-york" },
        { text: "New York", value: "new-york" },
        { text: "New York", value: "new-york" },
      ],
      statessuccess: false,
      statesdanger: false,
    };
  },
};
</script>